<template>
    <div class="detail-footer">
        <div class="station"></div>
        <footer class="footer" v-if="courseData">
            <!-- 判断课程未下线未购买 -->
            <template v-if="!is_mock && courseData.course_status == 2 && !buyData.is_buy">
                <template v-if="courseData.group_status == 1">
                    <!-- 拼团课程未开始 -->
                    <div class="footer-count" :class="courseData.flag == 3 ? 'spike-hide' : '' " v-if="groupData.group_start_time > 0 && courseData.group_status == 1 && !state.buy_start">
                        <div class="lt">
                            <p>距开始</p>
                            <van-count-down :time="groupData.group_start_time" format="DD 天 HH 时 mm 分 ss 秒" @finish="bindFinishPt" />
                        </div>
                    </div>
                    <!-- 拼团进倒计时 -->
                    <div class="footer-count footer-count-01" v-if="groupData !== '' && groupData.group_end_time > 0 && courseData.group_status == 1 && gu_id !== '0'" @click="toGroupDetail(gu_id)">
                        <div class="lt">
                            <p>还差{{state.user_num}}人拼团成功 剩余</p>
                            <van-count-down :time="groupData.group_end_time" fßormat="DD 天 HH:mm:ss "/>
                        </div>
                        <div class="rt">
                            <div class="head-img">
                                <img :src="item.avatar" v-for="(item ,index) in groupData.join_user" :key="item + index" class="img">
                            </div>
                            <i class="icon-right"></i>
                        </div>
                    </div>
                </template>
                <template v-else-if="courseData.status == 1">
                    <!-- 普通课程倒计时 -->
                    <div class="footer-count" :class="courseData.flag == 3 ? 'spike-hide' : '' " v-show="!state.is_start && !state.is_end && courseData.sale_start_time > 0">
                        <p>距开始还有</p>
                        <van-count-down :time="courseData.sale_start_time" format="DD 天 HH 时 mm 分 ss 秒" @finish="bindFinishStart"/>
                    </div>
                    <div class="footer-count" :class="courseData.flag == 3 ? 'spike-hide' : '' " v-show="state.is_start && !state.is_end && courseData.sale_end_time > 0">
                        <p>距结束还有</p>
                        <van-count-down :time="courseData.sale_end_time" format="DD 天 HH 时 mm 分 ss 秒" @finish="bindFinishEnd"/>
                    </div>
                </template>
            </template>
            
            <div class="footer-bt">
                <div class="lt">
                    <button class="item" @click="bindToHome">
                        <i class="icon-shop"></i>
                        <span>店铺</span>
                    </button>
                    <!-- 教育客服 -->
                    <button class="item kefu" :class="courseData.id && 'kefu_' + courseData.reception_id" v-if="courseData.reception_id !== 0 && state.kefuData.number !== '' && courseData.platform !== 2">
                        <i class="icon-kefu"></i>
                        <span>客服</span>
                    </button>
                    <!-- 在线售前客服 -->
                    <button class="item" v-if="courseData.platform == 2" @click="bindKefu()">
                        <i class="icon-kefu"></i>
                        <span>客服</span>
                    </button>
                </div>
                <div class="rt">
                    <template v-if="!is_spike && !is_mock && courseData.course_status == 2">
                        <!-- 普通课程 -->
                        <template v-if="courseData.status == 1 && courseData.group_status !== 1">
                            <!-- 课程已过期 -->
                            <template v-if="state.is_end">
                                <div class="btn btn-01">已下线</div>
                            </template>
                            <!-- 不限购or有库存 -->
                            <template v-else-if="courseData.limit_num == 0 || courseData.limit_num - courseData.buy_num > 0">
                                <div class="btn btn-01" v-show="!state.is_start">未开售</div>
                                <div class="btn" @click="onShowReceivePop(courseData.id)" v-if="state.is_start && !buyData.is_buy && is_receive && !had_received">立即领取</div>
                                <div class="btn" @click="bindBuyPop" v-else-if="state.is_start && (buyData.is_buy || (is_receive && if_current_receive(courseData.id)))">立即学习</div>
                                <div class="btn" @click="bindBuy(0)" v-else-if="state.is_start && (!buyData.is_buy || (is_receive && had_received && !if_current_receive(courseData.id)))">立即购买</div>
                            </template>
                            <template v-else>
                                <div class="btn btn-01">已售罄</div>
                            </template>
                        </template>
                        <!-- 拼团课程 -->
                        <template v-if="courseData.group_status == 1">
                            <!-- 是否购买 -->
                            <template v-if="buyData.is_buy || (is_receive && if_current_receive(courseData.id))">
                                <div class="btn" @click="bindBuyPop">
                                    <span class="tit">立即学习</span>
                                </div>
                            </template>
                            <!-- 是否库存充足 -->
                            <template v-else-if="courseData.limit_num !== 0 && courseData.limit_num - courseData.buy_num <= 0">
                                <div class="btn btn-01">已售罄</div>
                            </template>
                            <template v-else-if="is_receive && !had_received">
                                <div class="btn" @click="onShowReceivePop(courseData.id)">立即领取</div>
                            </template>
                            <template v-else>
                                <div class="btn-small btn-small-no" @click="bindBuy(0)">
                                    <span class="txt">¥{{courseData.price}}</span>
                                    <span class="tit">任性单买</span>
                                </div>
                                <!-- 库存数是否大于拼团人数 -->
                                <template v-if="courseData.limit_num !== 0 && courseData.limit_num - courseData.buy_num < groupData.limit_number && !groupData.is_join">
                                    <div class="btn-small btn-small-gray">库存不足</div>
                                </template>
                                <!-- 是否有团ID -->
                                <template v-else-if="gu_id !== '0'">
                                    <div class="btn-small btn-small-on" v-if="!groupData.is_join" @click="bindBuy(1)">
                                        <span class="txt">¥{{groupData.group_price}}</span>
                                        <span class="tit">立即参团</span>
                                    </div>
                                    <div class="btn-small btn-small-on" @click="toGroupDetailShare(gu_id)" v-if="groupData.is_join">
                                        <span class="txt">¥{{groupData.group_price}}</span>
                                        <span class="tit">参团中，去邀请</span>
                                    </div>
                                </template>
                                <template v-else>
                                    <div class="btn-small btn-small-on" @click="bindSharePop" v-if="groupData.joined_other_pid">
                                        <span class="txt">¥{{groupData.group_price}}</span>
                                        <span class="tit">发起拼团</span>
                                    </div>
                                    <div class="btn-small" :class="{'btn-small-gray':!state.buy_start,'btn-small-on':state.buy_start}" @click="bindBuy(1)" v-else>
                                        <span class="txt">¥{{groupData.group_price}}</span>
                                        <span class="tit">发起拼团</span>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-if="courseData.status !== 1 && courseData.group_status !== 1">
                            <div class="btn btn-01">已下线</div>
                        </template>
                    </template>
                    <template v-else-if="is_mock">
                        <button :disabled="courseData.is_end == 1" class="btn" :class="[courseData.is_end == 1 ? 'btn-01':'']" @click="bindRegister">{{courseData.is_end == 1 ? '活动已结束' : (courseData.is_register ? (courseData.subject_id == 8 ? '报名成功,点击此处可更改机构性质' : '报名成功,点击此处可更改地区') : '我要报名')}}</button>
                    </template>
                    <template v-else-if="is_spike">
                        <div class="btn" @click="bindBuyPop" v-if="buyData.is_buy">立即学习</div>
                        <!-- 秒杀未开始 -->
                        <template v-else-if="!state.is_start">
                            <div class="btn-small btn-small-no" @click="bindBuy(3)">
                                <span class="txt">¥{{courseData.origin_price}}</span>
                                <span class="tit">立即购买</span>
                            </div>
                            <div class="btn-small btn-small-gray">
                                <span class="txt">¥{{courseData.price}}</span>
                                <span class="tit">秒杀未开始</span>
                            </div>
                        </template>
                        <!-- 秒杀进行中 -->
                        <template v-else-if="!state.is_end">
                            <div class="btn column" @click="bindBuy(3)">
                                <span class="txt">¥{{courseData.price}}</span>
                                <span class="tit">立即购买</span>
                            </div>
                        </template>
                        <!-- 秒杀已结束 -->
                        <template v-else>
                            <div class="btn column" @click="bindBuy(3)">
                                <span class="txt">¥{{courseData.origin_price}}</span>
                                <span class="tit">立即购买</span>
                            </div>
                        </template>
                    </template>
                    <template v-else>
                        <div class="btn" @click="bindBuyPop" v-if="buyData.is_buy">立即学习</div>
                        <div class="btn btn-01" v-else>已下线</div>
                    </template>
                </div>
            </div>
        </footer>
        <!-- 购买须知 -->
        <buyNotice :show="state.buyShow" :isBuy="buyData.is_buy" @bindBuyPop="bindBuyPop" :courseData="courseData"></buyNotice>
        <!-- 领取课程弹窗 -->
        <confirmPop :show="state.receivePopShow" :course="courseData" @onClosePop="onClosePop"></confirmPop>
    </div>
</template>

<script>
import { getCurrentInstance, onMounted, watchEffect, reactive, computed} from "vue";
import { useRouter, useRoute } from "vue-router";
import { getStore, dedupe, sensorTrack } from "../../utils/util";
import { useStore } from "vuex";
import buyNotice from "../../components/detail/buynotice.vue";
import confirmPop from "../../components/confirmPop/index.vue";
export default {
	name: "detail-footer",
    components: {
		buyNotice,
        confirmPop
	},
    props: {
        courseData: Object,
        groupData: Object,
        buyData: Object,
        gu_id: String,
        userInfo:'',
        dis_id: ''
    },
	setup(props,context) {
        const { proxy } = getCurrentInstance();
        const $router = useRouter();
        const $route = useRoute();
        const store = useStore();
        const state = reactive({
            kefuData: [],//客服参数
            userInfo:'',//用户信息
            user_num:0,//还差参团人数
            buyShow: false,//购买须知弹窗
            Countdown:false,//倒计时是否结束
            is_start: false,//普通课程开售倒计时
            is_end: false,//普通课程结束倒计时
            receivePopShow: false,
            spikeStatus: 0, // 秒杀状态（未开始0，进行中1，已结束2）
        });
        let tmpReception_id;

        const is_mock = computed(() => {
            if(props.courseData != '') {
                return 'mock_range' in props.courseData
            }
        });

        // 判断是否为秒杀
        const is_spike = computed(() => {
            return props.courseData.flag == 3;
        });

        // 判断是否为领取课程
        const is_receive = computed(() => {
            return props.courseData.preview_flag == 1;
        });

        // 判断该用户是否已经领取了课程
        const had_received = computed(() => {
            return store.state.globalData.receive_id != -1;
        });

        // 判断用户领取的课程是否为传入id的课程
        const if_current_receive = computed(() => {
            return (cId) => {
                return store.state.globalData.receive_id != -1 && store.state.globalData.receive_id == cId;
            }
        });

        watchEffect(() => {
            if(props.courseData.reception_id && props.courseData.reception_id !== tmpReception_id){
                getKefu();//获取客服信息
                tmpReception_id = props.courseData.reception_id;
            }
            // 用户信息监听
            if(store.state.userInfo.userInfo){
                state.userInfo = store.state.userInfo.userInfo;
            }

            // 参团人数
            if(props.groupData){
                if(props.groupData.join_user){
                    state.user_num = props.groupData.limit_number - props.groupData.join_user.length;
                }
            }

            // 判断课程是否开售
            if(props.courseData.group_status!== undefined && props.courseData.group_status == 1 && !state.Countdown){
                if(props.groupData.group_start_time > 0){
                    state.buy_start = false;
                } else {
                    state.buy_start = true;
                    
                }
            }

            //普通课程开售时间
            console.log(props.courseData)
            if(props.courseData.sale_start_time !== undefined && props.courseData.sale_start_time > 0){
                state.is_start = false;
                state.is_end = false;
                // console.log("课程未开售")
            } else if(props.courseData.sale_end_time !== undefined && props.courseData.sale_start_time < 0 && props.courseData.sale_end_time > 0){
                state.is_start = true; 
                state.is_end = false;  
                // console.log("课程已开售")
            } else if(props.courseData.sale_start_time !== undefined && props.courseData.sale_end_time !== undefined && props.courseData.sale_start_time < 0 && props.courseData.sale_end_time < 0){
                state.is_start = true;
                state.is_end = true;
                // console.log("课程已过期")
            } else if(props.courseData.sale_start_time == null && props.courseData.sale_start_time !== undefined  || props.courseData.sale_end_time == null && props.courseData.sale_end_time !== undefined){
                state.is_start = true; 
                state.is_end = false;  
                // console.log("课程无活动时间")
            }
            
        })

        // 判断秒杀结束还是未开始（包括进行中）
        watchEffect(() => {
            let cData = props.courseData;
            if(cData && cData.sale_start_time) {
                if(cData.sale_start_time > 0) {
                    // 还没开始
                    state.spikeStatus = 0;
                } else if(cData.sale_end_time > 0) {
                    // 进行中
                    state.spikeStatus = 1;
                } else {
                    state.spikeStatus = 2;
                }
            }
        })

        onMounted(() => {
            let userInfo = getStore("userInfo");

			if (userInfo) {
				store.commit("userInfo/addUser", userInfo);
				state.userInfo = userInfo;
			}else {
				state.userInfo = '';
			}
        })

        /**
		 * 跳转登录页
		 */
		const toLogin = () => {
			$router.push({
				path: '/login'
			})
		}

        // 购买须知
        const bindBuyPop = () => {
            if(is_receive === true) {
                state.receivePopShow = !state.receivePopShow;
            } else {
                state.buyShow = !state.buyShow;
            }
        }

        /**
         * flag 0-推广订单1-拼团订单
         */
        const bindBuy = (flag) => {
            if(!state.buy_start && props.courseData.group_status == 1 && flag == 1){
                proxy.$toast("活动未开始");
            } else if(!state.userInfo.name){
                toLogin();//授权
            } else {
                if((!state.is_start && is_spike.value) || (state.is_end && is_spike.value)) {
                    flag = 0;
                }
                proxy.$toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true,
                    message: "加载中..."
                });
                
                sensorTrack({
                    eventName: 'HuaTuEducation_m_htxd_PurchaseCourese',
                    params: {
                        course_id: props.courseData.id,
                        course_title: props.courseData.title,
                        course_source: props.courseData.platform,
                        teach_way: props.courseData.type,
                        buy_type: props.courseData.group_status == 1 ? '拼团' : '普通',
                        price: props.courseData.price,
                        course_collage_price: props.courseData.group_status == 1 ? props.groupData.group_price : 0,
                        $url: window.location.href,
                        business_unit: props.courseData.department
                    }
                }).then(res => {
                    $router.push({
                        path: "/confirm",
                        query: {
                            shop_id: props.courseData.shop_id,
                            id: props.courseData.id,
                            flag: flag || '0',
                            group_id: props.groupData.id,
                            gu_user_id: props.gu_id
                        }
                    });
                })
            }
            
        }

        // 跳转拼团详情页
        const toGroupDetail  = (id) => {
            $router.push({
                path: "/groupDetail",
                query: {
                    gu_id: id,
                    source: "detail"
                }
            });
        }

        // 跳转拼团详情页展示分享弹窗
        const toGroupDetailShare  = (id) => {
            store.commit("globalData/addShare", true);//全局参数
            $router.push({
                path: "/groupDetail",
                query: {
                    gu_id: id,
                    source: "detail"
                }
            });
        }

        // 分享弹窗
        const bindSharePop = () => {
            if(props.groupData.joined_other_pid){
                proxy.$dialog.confirm({
                        title: '您已参加本课程拼团是否跳转？',
                        confirmButtonColor: '#FC6C21'
                    })
                        .then(() => {
                            toGroupDetail(props.groupData.joined_other_pid);
                        })
                        .catch(() => {
                            // on cancel
                        });
            } else {
                context.emit('bindSharePop');
            }
        }

        const htSobotInitFunc = (el, data) => {
            let { group_status, origin_price, price } = props.courseData;
            let { group_price } = props.groupData;
            let showPrice = price;
            // 确定页面上当前展示的价格
            if(is_spike.value && group_status !== 1) {
                showPrice = state.spikeStatus == 2 ? origin_price : price;
            } else {
                if(group_status === 1) {
                    showPrice = group_price;
                }
            }
            showPrice = '￥' + showPrice;
            let card = {
                card_title:props.courseData.title,
                card_url:encodeURI(window.location.href),
                // card_desc:"云客服,在线客服系统,云呼叫中心,机器人客服,工单客服,智能客服",
                card_note:showPrice,
                card_picture:encodeURI(props.courseData.thumb)
            }
            htSobot.init(el, Object.assign(data, {card}));
        }

        // 获取客服参数
        const getKefu = () => {
            proxy.$http.get("/api/course/consult/"+props.courseData.reception_id)
                .then(res => {
                    res.data.data = {}
                    res.data.data.number = props.courseData.reception_id
                    res.data.data.type = '2'
                    console.log("客服参数===>", res.data)
                    const body = res.data.data;
                    if(res.data.code == '200'){
                        state.kefuData = body;
                        if(state.kefuData.number){
                            if(state.kefuData.type == '0'){
                                htSobotInitFunc('kefu_' + props.courseData.reception_id, {service: 'branch-teach', ehr_code: state.kefuData.number, type: 'js', new_window: false, prod: true});
                            }else if(state.kefuData.type == '1'){
                                htSobotInitFunc('kefu_' + props.courseData.reception_id, {service: 'business', sys_id: state.kefuData.number, type: 'js', new_window: false, prod: true});
                            }else if(state.kefuData.type == '2'){
                                htSobotInitFunc('kefu_' + props.courseData.reception_id, {service: 'channel', sys_id: state.kefuData.number, type: 'js', new_window: false, prod: true});
                            }
                        }
                    } else {
                        proxy.$toast(body.message);
                    }
                })
                .catch(error => console.log(error))
        }

        // 在线客服
        const bindKefu = () => {
            let url = '';
            let title_info = props.courseData.title;
            let label_info = props.courseData.group_status == 1 ? props.groupData.group_price : props.courseData.price;
            let url_info = encodeURIComponent(window.location.href);
            let tel = props.userInfo.mobile; 
            // 区分售前售后客服
            if (!props.buyData.is_buy){
                console.log('1111-5')
                url = 'https://zsht.soboten.com/chat/h5/v6/index.html?sysnum=9c93277881f44e3e8c23090f055d1ae5&channelid=21&groupid=85183cc2fa3b478eb2fea36ba70f64b8&title_info='+ title_info +'&label_info='+ label_info +'&url_info='+url_info+'&tel='+ tel + '&type=4&robotid=6'
            } else {
                console.log('1111-6')
                url = 'https://zsht.soboten.com/chat/h5/v6/index.html?sysnum=9c93277881f44e3e8c23090f055d1ae5&channelid=21&groupid=85183cc2fa3b478eb2fea36ba70f64b8&title_info='+ title_info +'&label_info='+ label_info +'&url_info='+url_info+'&tel='+ tel +'&type=3&robotid=6'
            }

            // 跳转客服
            // console.log(url)
            window.location.href = url;
        }

        // 跳转店铺
        const bindToHome  = () => {
            $router.push({
                name: 'index',
                params: {
                    shop_id: props.courseData.shop_id
                }
            });
        }

        // 普通倒计时结束
        const bindFinishStart = () => {
            state.buy_start = 1;
            state.is_start = true;
            // console.log("普通课程开售倒计时结束",state.buy_start)
        }
        const bindFinishEnd = () => {
            // 判断当前课程有活动时间
            if(props.courseData.sale_start_time !== null && props.courseData.sale_end_time !== null){
                state.buy_start = 2;
                state.is_end = true;
                // console.log("普通课程过期倒计时结束",state.buy_start)
            }
        }


        // 拼团倒计时结束
        const bindFinishPt = () => {
            state.Countdown = true;
            state.buy_start = true;
        }

        // 模考大赛
        const bindRegister = () => {
            context.emit('bindMockRegister');
        }
       
        // 点击了立即领取
        const onShowReceivePop = (dis_id) => {
            console.log('我要领取课程:', dis_id);
            state.receivePopShow = true
        }

        // 领取课程弹窗关闭事件
        const onClosePop = (flag_hasReceive) => {
            state.receivePopShow = false;
            if(flag_hasReceive) {
                // 通知detail页面，重新加载课程data
                emit('refreshData');
            }
        }

		return {
            state,
            toGroupDetail,
            getKefu,
            bindBuy,
            bindToHome,
            bindSharePop,
            toLogin,
            bindBuyPop,
            bindFinishStart,
            bindFinishPt,
            bindFinishEnd,
            toGroupDetailShare,
            bindKefu,
            bindRegister,
            is_mock,
            is_spike,
            is_receive,
            had_received,
            if_current_receive,
            onShowReceivePop,
            onClosePop
		}
	}
};
</script>

<style scoped lang="scss" src="../../views/detail/index.scss"></style>
